import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import queryString from 'query-string'; 
import '../../assets/styles/LoginCallback.css';
import services from '../../services';
import { ApiResponse } from 'services/api/base';

interface Props {
}
interface State {
    userMessage: string;
    isError: boolean;

}
interface Params {
    token: string
}
interface UserInfo {

}
class LoginCallback extends React.PureComponent<RouteComponentProps<Params> & Props, State> {

    public state = {
        userMessage: 'logging in...please wait...',
        isError: false,
    };
    
    public async componentDidMount() {
        const params = queryString.parse(this.props.location.search);
        var token = params.token;
       
        if (token && ((typeof token === 'string' || token instanceof String))) {
            const tokenStr = token as string;
            var response: ApiResponse = await services.api.user.syncSession(tokenStr);

            if (response.isSuccess) {
                localStorage.setItem('token', tokenStr);
                const userData = response.data.user || response.data;
                localStorage.setItem('userInfo', JSON.stringify(userData));

                this.setState({ userMessage: 'Login successful. Redirecting...', isError: false });
                window.location = "/" as (string | Location) & Location;

            } else {
                localStorage.setItem('userInfo', '');
                localStorage.setItem('token', '');

                const msg = response.message || response.data?.message || 'Login declined. Account may be inactive.';
                
                this.setState({
                    userMessage: msg, 
                    isError: true
                });
            }
        } else {
             this.setState({ userMessage: "No token provided.", isError: true });
        }       
    }


    public render() {
        var homeLink = this.state.isError ? this.renderBackHomeLink() : "";
        return (
            <React.Fragment>
                <div className="main-message" >
                    <span>
                        <h2>{this.state.userMessage }</h2>
                    </span>
                </div>
                { homeLink }
            </React.Fragment>
            
        );
    }

    public renderBackHomeLink() {
        return (
            <React.Fragment>
                <div className="sub-message"><span><h2><a href="/">Compass Connect Home</a></h2></span></div>
            </React.Fragment>
        );
    }
}

export default LoginCallback;